@if (showAccessStatusBadge) {
  <ds-access-status-badge [object]="bitstream"></ds-access-status-badge>
}
@let bitstreamPath = bitstreamPath$ | async;
@let canDownload = canDownload$ | async;
@let canDownloadWithToken = canDownloadWithToken$ | async;

<a [routerLink]="bitstreamPath?.routerLink" class="d-block dont-break-out mb-1"
  [queryParams]="bitstreamPath?.queryParams"
  [target]="isBlank ? '_blank': '_self'"
  [ngClass]="cssClasses"
  [attr.aria-label]="getDownloadLinkTitle(canDownload, canDownloadWithToken, dsoNameService.getName(bitstream))"
  [title]="getDownloadLinkTitle(canDownload, canDownloadWithToken, dsoNameService.getName(bitstream))"
  role="link"
  tabindex="0">
  @if ((canDownload) === false && (canDownloadWithToken) === false) {
    <!-- If the user cannot download the file by auth or token, show a lock icon -->
    <span role="img"
    [attr.aria-label]="'file-download-link.restricted' | translate"
    [title]="'file-download-link.restricted' | translate"
    class="pe-1">
      <i class="fas fa-lock"></i>
    </span>
  } @else if (canDownloadWithToken && (canDownload === false)) {
    <!-- If the user can download the file by token, and NOT normally show a lock open icon -->
    <span role="img"
    [attr.aria-label]="'file-download-link.secure-access' | translate"
    [title]="'file-download-link.secure-access' | translate"
    class="pe-1 request-a-copy-access-icon">
      <i class="fa-solid fa-lock-open"></i>
    </span>
  } @else if (showIcon) {
    <i class="fas fa-download d-inline"></i>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
